const declarations = {
  getall: 'notification/getall',
  add: 'notification/add',
  remove: 'notification/remove',
  getlist: 'notification/getlist',
  get: 'notification/get',
  update: 'notification/update',
  getUserMessages: 'notification/get-by-userid',
  price: 'segment/get-price',
  examine: 'notification/examine',
  recurring: 'notification/recurring',
  getActions: 'notification/action-key-value'
}
export default declarations
